<template>
  <div data-test-id="form-simplified-enrollment-non-loyalty">
    <vf-notification
      v-if="notification.message"
      class="mb-4"
      :type="notification.type"
      @close="notification.message = ''"
    >
      {{ notification.message }}
    </vf-notification>
    <p :class="brandClasses.description">
      {{ $t.simplifiedEnrollment.nonLoyaltyDescription }}
    </p>
    <base-form class="mt-4 space-y-4" :form @submit="submit">
      <template v-for="item in (agreementCheckboxes as AgreementCheckbox[])" :key="item.type">
        <vf-form-field
          v-if="!('locales' in item) || (item.locales as LocaleCode[]).includes(useLocale())"
          v-slot="{ attrs }"
          class-wrapper="f-col"
          :name="item.type"
          :rule="item.required ? validateRequired('', $t.validators.requiredCheckbox) : []"
        >
          <vf-checkbox v-model="form[item.type]" v-bind="attrs" :required="item.required" size="sm">
            <form-legal-disclaimer
              :content="$t.brandAgreement[item.type]"
              :data-test-ids="{ 'loyalty-terms': 'form-sign-up-link-loyalty' }"
            />
          </vf-checkbox>
        </vf-form-field>
      </template>
      <div class="mt-6 space-y-2">
        <vf-button class="w-full" :loading type="submit">
          {{ $t.continue }}
        </vf-button>
        <vf-button class="w-full" :disabled="loading" variant="secondary" @click="emit('cancel')">
          {{ $t.maybeLater }}
        </vf-button>
      </div>
    </base-form>
  </div>
</template>

<script lang="ts" setup>
import type { AgreementCheckbox } from '#types/config/components/form/signUp'
import type { LocaleCode } from '#types/locale'
import type { BaseNotification } from '#types/notification'

const emit = defineEmits<{
  cancel: []
  continue: []
}>()

const { brandClasses } = useAppConfig().components.dialog.simplifiedEnrollment
const { agreementCheckboxes, isLoyaltyNewsletterAllowed } = useAppConfig().components.form.signUp
const { validateRequired } = useLocalizedValidators()
const subscription = useSubscriptions()

const loading = ref(false)

const form = reactive({
  newsletter: false,
  loyaltyTerms: false,
  brandTerms: false
})

const notification = reactive<BaseNotification>({
  message: '',
  type: 'info'
})

const submit = async () => {
  try {
    loading.value = true
    notification.message = ''

    await subscription.newsletter({
      loyaltyEnroll: true,
      loyaltyOptIn: isLoyaltyNewsletterAllowed || undefined,
      optIn: form.newsletter
    })

    emit('continue')
  }
  catch (err) {
    assertApiError(err)
    notification.message = err.message
    notification.type = 'error'
  }
  finally {
    loading.value = false
  }
}
</script>
